export const PENDING_REDIRECT_KEY = "vt-post-login-redirect";
export const PENDING_WORKSPACE_ALERT_KEY = "vt-post-login-workspace-alert";

const EXCLUDED_REDIRECT_HASHES = ["", "#/", "#/logged-out", "#/saml-success"];

const EXCLUDED_REDIRECT_HASH_PREFIXES = [
  "#/login",
  "#/systemAdminLogin",
  "#/exception",
  "#/user/password/expired",
  "#/user/password/reset",
];

export const capturePendingRedirect = () => {
  const { hash = "" } = window.location;
  const isExcluded =
    EXCLUDED_REDIRECT_HASHES.includes(hash) ||
    EXCLUDED_REDIRECT_HASH_PREFIXES.some((prefix) => hash.startsWith(prefix));
  if (!isExcluded) {
    localStorage.setItem(PENDING_REDIRECT_KEY, hash);
  }
};
